import { useContext, useEffect, useState } from "react";
import { getUsers } from "../api/apiRequests";
import { SessionContext } from "./wrappers/SessionWrapper";


const useUsers = () => {
  const { isLoggedIn } = useContext(SessionContext)
  const [users, setUsers] = useState()
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    refreshUsers()
    // eslint-disable-next-line
  }, [isLoggedIn])

  const refreshUsers = async () => {
    setLoading(true)
    if (isLoggedIn) {
      await getUsers()
        .then(res =>
          setUsers((res?.data || []).reverse()))
        .catch(() =>
          alert("¡Ups!, estamos teniendo dificultades con el servidor. Espere un instante y recargue la página"))
      setLoading(false)
    }
  };

  return {
    users,
    refreshUsers,
    isLoading
  }
}

export default useUsers